// extracted by mini-css-extract-plugin
export default {"searchBox":"Search_searchBox__HFM3s","inputSearch":"Search_inputSearch__sUYbA"};